import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoSectionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoSectionModel._instance == null) GeoSectionModel._instance = new GeoSectionModel(authManager);
        return GeoSectionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/geo-sections');

        this.entityName = 'geo-sections.GeoSection';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Geo Section';
        this.setLabel = 'Geo Sections';

        this.browser = {
            name: 'default-geo-sections-geosection-browser',
            moduleName: 'default-geo-sections-geosection-browser',
            moduleTitle: 'Geo Sections',
            moduleStateSlotName: 'default-geo-sections-geosection-browser',
        };

        this.editor = {
            name: 'default-geo-sections-geosection-editor',
            moduleName: 'default-geo-sections-geosection-editor',
            moduleTitle: 'Geo Section',
            moduleStateSlotName: 'default-geo-sections-geosection-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Comments',
            },
        ];

    }

}
